export default __webpack_public_path__ + "static/media/SG DE upd1.6ff62bd7.jpg";